import React, { FC, ReactNode, useContext, useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useTour } from '@reactour/tour';
// import { io } from "socket.io-client";
import Button, { IButtonProps } from '../../../components/bootstrap/Button';
import { HeaderRight } from '../../../layout/Header/Header';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../../components/bootstrap/OffCanvas';
import Alert, { AlertHeading } from '../../../components/bootstrap/Alert';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Icon from '../../../components/icon/Icon';
import ThemeContext from '../../../contexts/themeContext';
import LANG, { getLangWithKey, ILang } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import useDarkMode from '../../../hooks/useDarkMode';
import Popovers from '../../../components/bootstrap/Popovers';
import Spinner from '../../../components/bootstrap/Spinner';
import USERS from '../../../common/data/userDummyData';
import Avatar from '../../../components/Avatar';
import { socket } from "../../../services/socket";
import services from '../../../services';
// import notifSound from '../../../assets/audio/notif1.mp3';
interface ICommonHeaderRightProps {
	beforeChildren?: ReactNode;
	afterChildren?: ReactNode;
}
type Notification = {
  id: number | string;
  title: string;
  message: string;
  user_id: string;
  icon: string;
  link: string;
  is_read: boolean;
  created_at: string;
  donatur: string;
};

const CommonHeaderRight: FC<ICommonHeaderRightProps> = ({ beforeChildren, afterChildren }) => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
    const [notifications, setNotifications] = useState<Notification[]>([]);
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
	const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};
    const [notif, setNotif] = useState(false);
    const [messages, setMessages] = useState([]);
	const [offcanvasStatus, setOffcanvasStatus] = useState(false);
    const [userInteracted, setUserInteracted] = useState(false);

	const { i18n } = useTranslation();

	const changeLanguage = (lng: ILang['key']['lng']) => {
		i18n.changeLanguage(lng).then();
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
			'You updated the language of the site. (Only "Aside" was prepared as an example.)',
		);
	};

	/**
	 * Language attribute
	 */
	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language.substring(0, 2));
	});

	const { setIsOpen } = useTour();
	const storedData = sessionStorage.getItem('data');
    const userData = storedData ? JSON.parse(storedData) : '';
    let parsedData = null;
	if (storedData) {
		parsedData = JSON.parse(storedData);
	} else {
		console.log('No data found in localStorage.');
	}
    useEffect(() => {
        socket.on("set-notif-ulang-tahun", (dataString) => {
        const data = JSON.parse(dataString);
        // setNotifications((prev) => [
        //     {
        //     id: data.data?.notification_id ?? Date.now(),
        //     title: "🎉 Selamat Ulang Tahun!",
        //     message: "Semoga sehat dan sukses selalu.",
        //     is_read: false,
        //     created_at: new Date().toISOString(),
        //     },
        //     ...prev,
        // ]);
        console.log(data.jumlah_target);
        if (data.jumlah_target != 0) {
            showNotification(
                '',
                <div className='row d-flex align-items-center'>
                    <div className='col-auto'>
                        <Icon icon='CheckCircle' className='h1' />
                    </div>
                    <div className='col-auto h5'>🎉 Donatur Ulang Tahun.</div>
                </div>,
                'info',
            );
            // toast.info("🎉 Selamat Ulang Tahun! Semoga sehat dan sukses selalu.");
            setNotif(true);
        }
        });

        return () => {
        socket.off("set-notif-ulang-tahun");
        };
    }, []);
    useEffect(() => {
    if (offcanvasStatus) {
        fetchdata();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offcanvasStatus]);
    const unreadCount = notifications.filter((n) => !n.is_read).length;
    const handleRead = (id: any) => {
        setNotifications((prev) =>
        prev.map((n) =>
            n.id === id ? { ...n, is_read: true } : n
        )
        );
    };
    const fetchdata = async () => {
        setIsLoading(true);
        const aksesWig = userData.akses_id === 1
        const orderby = `{"xparam0":"","xparam1":""}`;
        const filter = `{"xparam0":"${userData.akses_id}","xparam1":"","xparam2":"","xparam3":"","xparam4":"","xparam5":"","xparam6":"","xparam7":""}`;
        try {
            const response = await services.pengguna.findAll(
                'notifikasi-group',
				0,
				10,
				filter,
				orderby,
            );

            if (response.data.rowcount > 0) {
                setNotifications(response.data.data)
                setIsLoading(false);
            } else {
                setNotifications([]);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            // eslint-disable-next-line no-console
            console.error('Error fetching data: ', error);
            // Handle errors here
        }
    };
    // useEffect(() => {
    //     const handleMouseMove = () => {
    //         setUserInteracted(true);
    //         window.removeEventListener('mousemove', handleMouseMove);
    //     };
    //     window.addEventListener('mousemove', handleMouseMove);
    //     const socket = io(`${process.env.REACT_APP_BASE_URL_SOCKET}`);
    //     socket.on("connect", () => {
    //         console.log("✅🔗Connected to the server");
    //     })
    //     socket.on("connect_error", (err) => {
    //         console.log(`connect_error due to ${err.message}`);
    //     });
    //     socket.on("set-notif-klasifikasi-donatur", (msg: any) => {
    //         setNotif(true);
    //         setMessages(JSON.parse(msg));
    //         if (userInteracted) {
    //             const audio = new Audio('/notif1.mp3');
                
    //             audio.play().catch(error => {
    //                 console.log('Audio play was prevented:', error);
    //             });
    //         }
    //     });
    //     return () => {
    //         window.removeEventListener('mousemove', handleMouseMove);
    //         socket.disconnect();
    //     };
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [userInteracted]);
	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}
				{/* Tour Modal */}
				{/* {localStorage.getItem('tourModalStarted') === 'shown' && (
					<div className='col-auto position-relative'>
						<Popovers trigger='hover' desc='Start the "Facit" tour'>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...styledBtn}
								icon='Tour'
								onClick={() => setIsOpen(true)}
								aria-label='Start the "Facit" tour'
							/>
						</Popovers>
						<Icon
							icon='Circle'
							className={classNames(
								'position-absolute start-65',
								'text-danger',
								'animate__animated animate__heartBeat animate__infinite animate__slower',
							)}
						/>
					</div>
				)} */}

				{/* Dark Mode */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Dark / Light mode'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							onClick={() => setDarkModeStatus(!darkModeStatus)}
							className='btn-only-icon'
							data-tour='dark-mode'
							aria-label='Toggle dark mode'>
							<Icon
								icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
								color={darkModeStatus ? 'info' : 'warning'}
								className='btn-icon'
							/>
						</Button>
					</Popovers>
				</div>

				{/*	Full Screen */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Fullscreen'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
							onClick={() => setFullScreenStatus(!fullScreenStatus)}
							aria-label='Toggle fullscreen'
						/>
					</Popovers>
				</div>

				{/* Lang Selector */}
				{/* <div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							{typeof getLangWithKey(i18n.language as ILang['key']['lng'])?.icon ===
							'undefined' ? (
								<Button
									// eslint-disable-next-line react/jsx-props-no-spreading
									{...styledBtn}
									className='btn-only-icon'
									aria-label='Change language'
									data-tour='lang-selector'>
									<Spinner isSmall inButton='onlyIcon' isGrow />
								</Button>
							) : (
								<Button
									// eslint-disable-next-line react/jsx-props-no-spreading
									{...styledBtn}
									icon={
										getLangWithKey(i18n.language as ILang['key']['lng'])?.icon
									}
									aria-label='Change language'
									data-tour='lang-selector'
								/>
							)}
						</DropdownToggle>
						<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
							{Object.keys(LANG).map((i) => (
								<DropdownItem key={LANG[i].lng}>
									<Button
										icon={LANG[i].icon}
										onClick={() => changeLanguage(LANG[i].lng)}>
										{LANG[i].text}
									</Button>
								</DropdownItem>
							))}
						</DropdownMenu>
					</Dropdown>
				</div> */}

				{/*	Notifications */}
				<div className='col-auto position-relative'>
					<Button
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...styledBtn}
                        // className='bg-transparent'
						icon='Notifications'
						onClick={() => {
                            setOffcanvasStatus(true);
                            setNotif(false);
                        }}
						aria-label='Notifications'
					/>
                    {notif && (
                        <Icon
                        icon='Circle'
                        className={classNames(
                            'position-absolute start-65',
                            'text-danger',
                            'animate__animated animate__heartBeat animate__infinite animate__slower',
                        )}
                        />
                    )}
				</div>

				{/* Quick Panel */}
				<div className='col-auto'>
					<div className='col d-flex align-items-center' role='presentation'>
						<div className='me-3'>
							<div className='text-end'>
								<div className='fw-bold fs-6 mb-0'>{`${parsedData?.name}`}</div>
								<div className='text-muted'>
									<small>{parsedData?.username}</small>
								</div>
							</div>
						</div>
						<div className='position-relative'>
							<Avatar
								srcSet={
									parsedData?.jenis_kelamin == 1
										? USERS.JOHN.srcSet
										: USERS.CHLOE.srcSet
								}
								src={
									parsedData?.jenis_kelamin == 1
										? USERS.JOHN.src
										: USERS.CHLOE.src
								}
								size={48}
								color={USERS.CHLOE.color}
							/>
						</div>
					</div>
				</div>
				{/* {afterChildren} */}
			</div>

            <OffCanvas
                id="notificationCanvas"
                titleId="offcanvasExampleLabel"
                placement="end"
                isOpen={offcanvasStatus}
                setOpen={setOffcanvasStatus}
                >
                <OffCanvasHeader setOpen={setOffcanvasStatus}>
                    <OffCanvasTitle id="offcanvasExampleLabel">Notifications</OffCanvasTitle>
                </OffCanvasHeader>

                <OffCanvasBody className="space-y-2">
                    {notifications.length === 0 && (
                    <p className="text-muted text-center mt-4">Tidak ada notifikasi</p>
                    )}

                    {/* --- Grupkan notifikasi berdasarkan tanggal created_at --- */}
                    {Object.entries(
                    notifications.reduce<Record<string, Notification[]>>((acc, mnotif) => {
                        const date = new Date(mnotif.created_at).toISOString().split("T")[0];
                        if (!acc[date]) acc[date] = [];
                        acc[date].push(mnotif);
                        return acc;
                    }, {})
                    )
                    // Urutkan dari tanggal terbaru ke terlama
                    .sort(([a], [b]) => new Date(b).getTime() - new Date(a).getTime())
                    .map(([date, notifs]) => (
                        <div key={date} className="mb-4">
                        {/* Pemisah tanggal */}
                        <div className="flex items-center mb-2">
                            <hr className="flex-grow border-gray-300" />
                            <span className="mx-2 text-gray-500 text-sm font-semibold">
                            {new Date(date).toLocaleDateString("id-ID", {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                            })}
                            </span>
                            <hr className="flex-grow border-gray-300" />
                        </div>

                        {/* Daftar notifikasi per tanggal */}
                        {notifs.map((notifdetail) => (
                            <Alert
                            key={notifdetail.id}
                            color="info"
                            shadow="md"
                            isLight
                            className="d-flex flex-column gap-2 p-3 rounded-3"
                            icon={notifdetail.icon}
                            >
                            <div className="d-flex justify-content-between align-items-start">
                                <AlertHeading className="fw-bold m-0">
                                {notifdetail.title || "Selamat Ulang Tahun 🎉"}
                                </AlertHeading>
                            </div>

                            <p className="mb-0">
                                {notifdetail.message || "Selamat ulang tahun! Semoga sehat dan sukses selalu."}
                            </p>

                            {notifdetail.donatur && (
                                <h6 className="mt-2">
                                    🎉 {notifdetail.donatur}
                                </h6>
                            )}

                            {/* tombol hanya muncul kalau ada link */}
                            {notifdetail.link && (
                                <div className="mt-2">
                                <Button
                                    color="primary"
                                    size="sm"
                                    to={`../detail-donatur/${notifdetail.user_id}`}
                                    className="ms-auto"
                                >
                                    Lihat Detail
                                </Button>
                                </div>
                            )}
                            </Alert>

                        ))}
                        </div>
                    ))}
                </OffCanvasBody>
            </OffCanvas>

		</HeaderRight>
	);
};
(CommonHeaderRight as any).propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

export default CommonHeaderRight;
